import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './css/style.css';
import './css/content.css';
import './css/login.css';
import './css/ExtendedInfo.css';
import Router from './router'
// import indexjsx from './jsx/index'
import * as serviceWorker from './serviceWorker';




ReactDOM.render(<Router />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
